import FormItem from '@/components/Form/FormItem';
import PasswordInput from '@/components/Form/PasswordInput';
import Spin from '@/components/Spin';
import { UNKNOWN_ERROR_MESSAGE } from '@/config';
import { ModalUtils } from '@/contexts/ModalWrapper';
import { FormValidation } from '@/helpers/formValidations';
import { apiSdk } from '@/httpClient';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Modal, ModalBody } from 'reactstrap';

type Props = {
  onClose: () => void;
};

export default function ChangePasswordModal({ onClose }: Props) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const changePassword = (values: any) => {
    setLoading(true);
    apiSdk.AgentUserService.changePassword({
      body: {
        oldPassword: values.oldPassword,
        password: values.password,
      },
    })
      .then(res => {
        if (res.success) {
          ModalUtils.success({
            title: 'Change password successful',
            onClose: () => onClose(),
          });
        } else {
          ModalUtils.error({
            title: t(res.message || UNKNOWN_ERROR_MESSAGE),
          });
        }
      })
      .catch(() => {
        ModalUtils.error({
          content: t(UNKNOWN_ERROR_MESSAGE),
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <Modal isOpen={true} unmountOnClose={true}>
      <ModalBody>
        <Spin loading={loading}>
          <div className="text-18 fw-500 mb-10">{'Change password'}</div>
          <form className="row y-gap-10 x-gap-5" onSubmit={handleSubmit(changePassword)}>
            <div className="col-12">
              <FormItem errors={errors} label="Current password" name="oldPassword">
                <PasswordInput {...register('oldPassword', FormValidation.Required)} />
              </FormItem>
            </div>

            <div className="col-12">
              <FormItem errors={errors} label="Password" name="password">
                <PasswordInput {...register('password', FormValidation.Required)} />
              </FormItem>
            </div>
            <div className="col-12">
              <FormItem errors={errors} label={t('resetPasswordPage_ConfirmPassword')} name="confirmPassword">
                <PasswordInput
                  {...register('confirmPassword', {
                    validate: (confirmPassword: string) => {
                      if (watch('password') !== confirmPassword) {
                        return t('resetPasswordPage_PasswordNotMatch') as any;
                      }
                      return undefined;
                    },
                  })}
                />
              </FormItem>
            </div>
            <div className="italic text-light-1">
              <div dangerouslySetInnerHTML={{ __html: t('PASS_WORD_HINT_TEXT') as any }} />
            </div>
            <div className="col-12 d-flex justify-end">
              <button
                type="button"
                className="button px-15 py-10 -outline-light-1 mr-10"
                onClick={() => {
                  onClose();
                }}
              >
                <i className="icon-close text-12 px-5" />
                Close
              </button>
              <button type="submit" className="button px-15 bg-blue-1  py-10 text-white" onClick={() => {}}>
                <i className="icon-check text-12 px-5" />
                Save
              </button>
            </div>
          </form>
        </Spin>
      </ModalBody>
    </Modal>
  );
}
